import 'css-chunksrc/client/scenes/projectExpenseEdition/form/expenseTypeSelect/styles.scss';export default {
  "root": "_root_2xofe_1",
  "listRoot": "_listRoot_2xofe_5",
  "list": "_list_2xofe_5",
  "icon": "_icon_2xofe_29",
  "input": "_input_2xofe_38",
  "opened": "_opened_2xofe_56",
  "option": "_option_2xofe_66",
  "selected": "_selected_2xofe_71"
};